// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CampaignImportController from "./campaign_import_controller"
application.register("campaign-import", CampaignImportController)

import ChatMessagesController from "./chat_messages_controller"
application.register("chat-messages", ChatMessagesController)

import DiscountSearchController from "./discount_search_controller"
application.register("discount-search", DiscountSearchController)

import ExitIntentController from "./exit_intent_controller"
application.register("exit-intent", ExitIntentController)

import HalloweenController from "./halloween_controller"
application.register("halloween", HalloweenController)

import HomeController from "./home_controller"
application.register("home", HomeController)

import LessonController from "./lesson_controller"
application.register("lesson", LessonController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import OrderController from "./order_controller"
application.register("order", OrderController)

import PaymentController from "./payment_controller"
application.register("payment", PaymentController)

import ReportUserTagController from "./report_user_tag_controller"
application.register("report-user-tag", ReportUserTagController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SidenavController from "./sidenav_controller"
application.register("sidenav", SidenavController)

import UserController from "./user_controller"
application.register("user", UserController)

import UserSearchController from "./user_search_controller"
application.register("user-search", UserSearchController)
